import React, { useMemo, useState } from "react";
import {
  IconButton,
  Badge,
  Menu,
  MenuItem,
  ListSubheader,
} from "@mui/material";
import SvgIcon from "../../helpers/SvgIcon";
import { expeditionRoutes } from "../routesConstants";
import { useAppSelector } from "../../redux/hooks";

export default function AlertsBellMenu() {
  const { total: totalAlertsCount, data: alertsCountData } = useAppSelector(
    (state) => state.admin.alertsCount.data,
  );

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(e.currentTarget);

  const handleClose = () => setAnchorEl(null);

  const alertsCountDropdownValues = useMemo(
    () =>
      (alertsCountData ?? []).map((item) => ({
        id: item.id_client,
        label: item.client,
        count: item.puncte_nevalidate,
      })),
    [alertsCountData],
  );

  return (
    <>
      <IconButton
        id="navbar-notifications-trigger"
        aria-label={`Notificări: ${totalAlertsCount ?? 0}`}
        aria-haspopup="menu"
        aria-controls={open ? "navbar-notifications-menu" : undefined}
        aria-expanded={open}
        className="!h-[44px] !w-[44px] !rounded-control !text-muted-dark hover:!bg-surface-subtle"
        onClick={handleOpen}>
        <Badge
          badgeContent={totalAlertsCount}
          color="error"
          max={99}
          sx={{
            "& .MuiBadge-badge": {
              minWidth: 18,
              height: 18,
              px: 0.5,
              fontSize: 10,
              fontWeight: 600,
              border: "2px solid white",
              top: 1,
              right: 1,
            },
          }}>
          <SvgIcon
            type="NOTIFICATIONS_ICON"
            fill="currentColor"
            className="!h-[23px] !w-[23px]"
          />
        </Badge>
      </IconButton>

      <Menu
        id="navbar-notifications-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        MenuListProps={{ "aria-labelledby": "navbar-notifications-trigger" }}
        PaperProps={{
          sx: {
            mt: 1,
            width: 340,
            maxWidth: "calc(100vw - 24px)",
            maxHeight: "70vh",
            borderRadius: 2,
          },
        }}>
        <ListSubheader className="!static !bg-white !px-4 !py-2 !text-[14px] !font-semibold !leading-normal !text-slate-800">
          Notificări
        </ListSubheader>
        {alertsCountDropdownValues && alertsCountDropdownValues.length ? (
          alertsCountDropdownValues.map((item) => (
            <MenuItem
              key={item.id}
              component="a"
              onClick={handleClose}
              className="!mx-2 !my-1 !items-start !gap-3 !whitespace-normal !rounded-lg !px-3 !py-3 !text-[13px] !leading-relaxed !text-slate-700"
              href={`/${expeditionRoutes.clients}/${item.id}/${
                expeditionRoutes.clientsWorkingPoints
              }?denumireClient=${encodeURIComponent(item.label)}`}>
              <span className="min-w-0 flex-1 break-words">{item.label}</span>
              <span className="shrink-0 rounded-control bg-danger-subtle px-2 text-[12px] font-semibold text-danger">
                {item.count}
              </span>
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>Fara notificari</MenuItem>
        )}
      </Menu>
    </>
  );
}
